export const lineReductionQuery = {
	bool: {
		should: [
			{
				bool: {
					must: [
						{
							exists: {
								field: 'line',
							},
						},
						{
							range: {
								sportsbookProbability: {
									gte: 45.5,
									lte: 58.3,
								},
							},
						},
					],
				},
			},
			{
				bool: {
					must_not: [
						{
							exists: {
								field: 'line',
							},
						},
					],
				},
			},
		],
		minimum_should_match: 1,
	},
};
